import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CashflowDto } from '@dto/cashflowDto';
import { Observable } from 'rxjs';
import { DashboardProfile } from '../../dto/dashboardProfile';
import { EntityService } from '../entity/entity.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends EntityService {

  public entityRoute = "dashboard";

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  getDashboardProfile(): Observable<DashboardProfile> {
    return this.http.get<DashboardProfile>(this.baseUrl + 'api/dashboard/profile');
  }

  getDashboardProfileOfCustomer(customerId: number): Observable<DashboardProfile> {
    return this.http.get<DashboardProfile>(this.baseUrl + 'api/customers/' + customerId + '/dashboard');
  }

  getCashflowOfCustomer(customerId: number): Observable<CashflowDto> {
    return this.http.get<CashflowDto>(this.baseUrl + 'api/dashboard/cashflow/customer/' + customerId);
  }

  getCashflowOfUser(userId: string): Observable<CashflowDto> {
    return this.http.get<CashflowDto>(this.baseUrl + 'api/dashboard/cashflow/user/' + userId);
  }

  matches() {
    return true;
  }
}
